module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp2-03-69516dde705e1a99b919832815d4e94b.png";